'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _slateEditTable = require('@gitbook/slate-edit-table');

var _slateEditTable2 = _interopRequireDefault(_slateEditTable);

var _EditListPlugin = require('../plugins/EditListPlugin');

var _EditListPlugin2 = _interopRequireDefault(_EditListPlugin);

var _TopicColors = require('../TopicColors');

var _TopicColors2 = _interopRequireDefault(_TopicColors);

var _ClearStrategy = require('../strategies/ClearStrategy');

var _ClearStrategy2 = _interopRequireDefault(_ClearStrategy);

var _AlignButton = require('./AlignButton');

var _AlignButton2 = _interopRequireDefault(_AlignButton);

var _BlockButton = require('./BlockButton');

var _BlockButton2 = _interopRequireDefault(_BlockButton);

var _ColorButton = require('./ColorButton');

var _ColorButton2 = _interopRequireDefault(_ColorButton);

var _ListItemButton = require('./ListItemButton');

var _ListItemButton2 = _interopRequireDefault(_ListItemButton);

var _ListBlockButton = require('./ListBlockButton');

var _ListBlockButton2 = _interopRequireDefault(_ListBlockButton);

var _InlineButton = require('./InlineButton');

var _InlineButton2 = _interopRequireDefault(_InlineButton);

var _MarkButton = require('./MarkButton');

var _MarkButton2 = _interopRequireDefault(_MarkButton);

var _PlainButton = require('./PlainButton');

var _PlainButton2 = _interopRequireDefault(_PlainButton);

var _ToolbarButton = require('./ToolbarButton');

var _ToolbarButton2 = _interopRequireDefault(_ToolbarButton);

var _ToolbarMenu = require('./ToolbarMenu');

var _ToolbarMenu2 = _interopRequireDefault(_ToolbarMenu);

var _TableToolbarMenu = require('./TableToolbarMenu');

var _TableToolbarMenu2 = _interopRequireDefault(_TableToolbarMenu);

var _TableButton = require('./TableButton');

var _TableButton2 = _interopRequireDefault(_TableButton);

var _VoidButton = require('./VoidButton');

var _VoidButton2 = _interopRequireDefault(_VoidButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isSelectionInTable = (0, _slateEditTable2.default)().utils.isSelectionInTable;
var _EditListPlugin$utils = _EditListPlugin2.default.utils,
    isSelectionInList = _EditListPlugin$utils.isSelectionInList,
    getCurrentList = _EditListPlugin$utils.getCurrentList;


var renderPatterns = function renderPatterns(insideExamples, sharedProps) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'small',
      null,
      'Patterns'
    ),
    !insideExamples && _react2.default.createElement(_BlockButton2.default, _extends({ block: 'heading-one', icon: 'angle-double-up', title: 'Header One' }, sharedProps)),
    !insideExamples && _react2.default.createElement(_BlockButton2.default, _extends({ block: 'heading-two', icon: 'angle-up', title: 'Header Two' }, sharedProps)),
    _react2.default.createElement(_ListBlockButton2.default, _extends({ block: 'pattern__examples', icon: 'lightbulb-o', text: 'Examples' }, sharedProps)),
    _react2.default.createElement(_ListBlockButton2.default, _extends({ block: 'pattern__conversation', icon: 'comments', text: 'Conversation' }, sharedProps)),
    _react2.default.createElement(_ListBlockButton2.default, _extends({ block: 'pattern__center', icon: 'book', text: 'Centered Aside' }, sharedProps)),
    _react2.default.createElement(_ListBlockButton2.default, _extends({ block: 'pattern__watchout', icon: 'exclamation-triangle', text: 'Watch Out Aside' }, sharedProps)),
    _react2.default.createElement(_ListBlockButton2.default, _extends({ block: 'pattern__cultural', icon: 'globe', text: 'Cultural Aside' }, sharedProps)),
    _react2.default.createElement(_ListBlockButton2.default, _extends({ block: 'pattern__note', icon: 'sticky-note', text: 'Note Aside' }, sharedProps))
  );
};

var renderInExamples = function renderInExamples(sharedProps) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'small',
      null,
      'Examples'
    ),
    _react2.default.createElement(_ListItemButton2.default, _extends({ data: { className: 'text' }, icon: 'sign-language', title: 'Examples Text' }, sharedProps)),
    _react2.default.createElement(_ListItemButton2.default, _extends({ data: { className: 'translation' }, icon: 'american-sign-language-interpreting', title: 'Examples Translation' }, sharedProps))
  );
};

var renderInConversation = function renderInConversation(sharedProps) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'small',
      null,
      'Conversations'
    ),
    _react2.default.createElement(_ListItemButton2.default, _extends({ data: { className: 'student' }, icon: 'user', title: 'Student' }, sharedProps)),
    _react2.default.createElement(_ListItemButton2.default, _extends({ data: { className: 'tutor' }, icon: 'user', title: 'Tutor' }, sharedProps))
  );
};

var TopicToolbar = function TopicToolbar(_ref) {
  var menus = _ref.menus,
      value = _ref.value,
      mobileView = _ref.mobileView,
      onChange = _ref.onChange,
      onMenuToggle = _ref.onMenuToggle,
      onMobileToggle = _ref.onMobileToggle,
      onClickUndo = _ref.onClickUndo,
      onClickRedo = _ref.onClickRedo;

  var insideTable = isSelectionInTable(value);
  var insideList = isSelectionInList(value);
  var insideExamples = false;
  var insideConversation = false;
  if (insideList) {
    var currentList = getCurrentList(value);
    insideExamples = currentList.type === 'pattern__examples';
    insideConversation = currentList.type === 'pattern__conversation';
  }
  var sharedProps = {
    value: value, onChange: onChange, insideTable: insideTable, insideList: insideList
  };
  var menuProps = { menus: menus, onMenuToggle: onMenuToggle };

  return _react2.default.createElement(
    'div',
    { className: 'menu toolbar-menu' },
    _react2.default.createElement(
      'div',
      { className: 'toolbar-menu__right' },
      _react2.default.createElement(_ToolbarButton2.default, {
        title: 'View as in mobile app',
        text: 'mobile',
        active: mobileView,
        onMouseDown: onMobileToggle
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'toolbar-menu__left' },
      _react2.default.createElement(_MarkButton2.default, _extends({ mark: 'bold', icon: 'bold', title: 'Bold' }, sharedProps)),
      _react2.default.createElement(_MarkButton2.default, _extends({ mark: 'italic', icon: 'italic', title: 'Italic' }, sharedProps)),
      _react2.default.createElement(_MarkButton2.default, _extends({ mark: 'underline', icon: 'underline', title: 'Underline' }, sharedProps)),
      _react2.default.createElement(_MarkButton2.default, _extends({ mark: 'strikethrough', icon: 'strikethrough', title: 'Strikethrough' }, sharedProps)),
      _react2.default.createElement(_InlineButton2.default, _extends({ inline: 'learning-language', icon: 'language', title: 'Learning Language' }, sharedProps)),
      _react2.default.createElement('div', { className: 'separator' }),
      _react2.default.createElement(_AlignButton2.default, _extends({ align: 'left', icon: 'align-left', title: 'Left Align' }, sharedProps)),
      _react2.default.createElement(_AlignButton2.default, _extends({ align: 'center', icon: 'align-center', title: 'Center Align' }, sharedProps)),
      _react2.default.createElement(_AlignButton2.default, _extends({ align: 'right', icon: 'align-right', title: 'Right Align' }, sharedProps)),
      _react2.default.createElement(_ListBlockButton2.default, _extends({ block: 'ol_list', icon: 'list-ol', title: 'Numbered List' }, sharedProps)),
      _react2.default.createElement(_ListBlockButton2.default, _extends({ block: 'ul_list', icon: 'list-ul', title: 'Bulleted List' }, sharedProps)),
      _react2.default.createElement('div', { className: 'separator' }),
      _react2.default.createElement(
        _ToolbarMenu2.default,
        _extends({ type: 'color', icon: 'eyedropper', title: 'Font Color' }, menuProps),
        Object.entries(_TopicColors2.default).map(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              color = _ref3[0],
              colorProps = _ref3[1];

          return _react2.default.createElement(_ColorButton2.default, _extends({ color: color, key: color, title: colorProps.title + ' (' + (colorProps.hotkey || 'No shortcut') + ')', icon: 'font' }, sharedProps));
        })
      ),
      _react2.default.createElement(
        _ToolbarMenu2.default,
        _extends({ type: 'character', icon: 'keyboard-o', title: 'Character Map' }, menuProps),
        _react2.default.createElement(
          'div',
          { className: 'menu' },
          _react2.default.createElement(_PlainButton2.default, _extends({ text: '\u2190', title: 'Left Arrow' }, sharedProps)),
          _react2.default.createElement(_PlainButton2.default, _extends({ text: '\u2192', title: 'Right Arrow' }, sharedProps)),
          _react2.default.createElement(_PlainButton2.default, _extends({ text: '\u2194', title: 'Left Right Arrow' }, sharedProps)),
          _react2.default.createElement(_PlainButton2.default, _extends({ text: '\u21D0', title: 'Leftwards Double Arrow' }, sharedProps)),
          _react2.default.createElement(_PlainButton2.default, _extends({ text: '\u21D2', title: 'Rightwards Double Arrow' }, sharedProps))
        ),
        _react2.default.createElement(
          'div',
          { className: 'menu' },
          _react2.default.createElement(_PlainButton2.default, _extends({ text: '\u2026', title: 'Ellipsis' }, sharedProps)),
          _react2.default.createElement(_PlainButton2.default, _extends({ text: '\xAB', title: 'Double Low Quote' }, sharedProps)),
          _react2.default.createElement(_PlainButton2.default, _extends({ text: '\xBB', title: 'Double High Quote' }, sharedProps)),
          _react2.default.createElement(_PlainButton2.default, _extends({ text: '\u201E', title: 'Double Angle Left Quote' }, sharedProps)),
          _react2.default.createElement(_PlainButton2.default, _extends({ text: '\u201D', title: 'Double Angle Right Quote' }, sharedProps))
        )
      ),
      _react2.default.createElement(
        _ToolbarMenu2.default,
        _extends({ type: 'rule', icon: 'reorder', title: 'Rules' }, menuProps),
        _react2.default.createElement(_VoidButton2.default, _extends({ type: 'underbar', text: '4: ____', title: 'Small Space' }, sharedProps)),
        _react2.default.createElement(_VoidButton2.default, _extends({ type: 'underbar_l', text: '6: ______', title: 'Medium Space' }, sharedProps)),
        _react2.default.createElement(_VoidButton2.default, _extends({ type: 'underbar_xl', text: '8: ________', title: 'Large Space' }, sharedProps)),
        _react2.default.createElement(_VoidButton2.default, _extends({ type: 'horizontal-rule', text: 'HR: \u2014\u2014\u2014\u2014\u2014\u2014\u2014', title: 'Horizontal Rule' }, sharedProps))
      ),
      _react2.default.createElement(
        _ToolbarMenu2.default,
        _extends({ type: 'tables', icon: 'table', title: 'Tables' }, menuProps),
        _react2.default.createElement(_TableButton2.default, _extends({ type: 'table_arrow', icon: 'arrow-right', title: 'Arrow Table' }, sharedProps)),
        _react2.default.createElement(_TableButton2.default, _extends({ type: 'table_two', icon: 'th-large', title: 'Two Column Table' }, sharedProps)),
        _react2.default.createElement(_TableButton2.default, _extends({ type: 'table_three', icon: 'table', title: 'Three Column Table' }, sharedProps)),
        insideTable && _react2.default.createElement(_TableToolbarMenu2.default, sharedProps)
      ),
      _react2.default.createElement(
        _ToolbarMenu2.default,
        _extends({ type: 'patterns', icon: 'paint-brush', title: 'Patterns' }, menuProps),
        _react2.default.createElement(_ToolbarButton2.default, {
          text: 'Clear Formatting',
          title: 'Clear Formatting',
          icon: 'paragraph',
          onMouseDown: function onMouseDown(e) {
            return onChange((0, _ClearStrategy2.default)(value));
          }
        }),
        insideExamples && renderInExamples(sharedProps),
        insideConversation && renderInConversation(sharedProps),
        !insideTable && renderPatterns(insideExamples, sharedProps)
      ),
      _react2.default.createElement('div', { className: 'separator' }),
      _react2.default.createElement(_ToolbarButton2.default, { icon: 'undo', title: 'Undo', onMouseDown: onClickUndo }),
      _react2.default.createElement(_ToolbarButton2.default, { icon: 'repeat', title: 'Redo', onMouseDown: onClickRedo })
    )
  );
};

TopicToolbar.propTypes = {
  menus: _propTypes2.default.object.isRequired,
  mobileView: _propTypes2.default.bool.isRequired,
  value: _propTypes2.default.object.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  onMenuToggle: _propTypes2.default.func.isRequired,
  onMobileToggle: _propTypes2.default.func.isRequired,
  onClickUndo: _propTypes2.default.func.isRequired,
  onClickRedo: _propTypes2.default.func.isRequired
};

exports.default = TopicToolbar;